import { h, Component } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Router, route } from "preact-router";
import MobilePage from "../../utils/mobile-page";

import { openPopup } from "../../utils/popups";

import PFeed from "../../../../services/prematch-feed";
import LFeed from "../../../../services/live-feed";
import CFeed from "../../../../services/casino-feed";
import User from "../../../../services/user";

import * as S from "../../mobile-templates/sports";
import * as I from "../../utils/icons";

import {
	UserIcon,
	CloseIconSlim,
	HelpIcon,
} from "../../mobile-templates/general";
import { NewBadge } from "../../desktop-components/site/main-menu";

import AwrabetMenuLeft, {
	SlidingContainer as AwrabetSlidingContainer,
} from "../../../awrabet/mobile-components/site/menu-left";

export class SlidingContainer extends AwrabetSlidingContainer {
	render({ children }) {
		return (
			<div
				id="left-menu"
				class={
					"fixed z-10 -left-full top-0 bottom-0 w-full bg-black/70 pr-12 transition-all " +
					(MobilePage.isLeftMenuOpen() ? "translate-x-full" : "")
				}
				onClick={(e) => {
					if (e.target != e.currentTarget) return;
					MobilePage.closeLeftMenu();
				}}
			>
				{children}
			</div>
		);
	}
}

const MenuEntry = ({ regex, ...props }) => {
	const isActive = regex
		? regex.test(window.location.pathname)
		: window.location.pathname == props.href;
	return (
		<a
			{...props}
			onClick={(e) => {
				MobilePage.closeLeftMenu();
				if (props.onClick) props.onClick(e);
			}}
			class={
				"relative flex h-12 items-center justify-center px-2 uppercase text-white " +
				(props["class"] || "") +
				(isActive ? " bg-custom-orange" : " bg-harif-900")
			}
		/>
	);
};

export default class MenuLeft extends AwrabetMenuLeft {
	render() {
		return (
			<SlidingContainer>
				<div
					class="absolute top-0 right-0 w-12 p-1 pt-2 text-white"
					onClick={(e) => MobilePage.closeLeftMenu()}
				>
					<CloseIconSlim />
				</div>
				<div class="flex h-full w-full max-w-sm flex-col border-r border-black bg-blue-whale-800 text-white">
					<HorizontalTopMenu onClick={(e) => MobilePage.closeLeftMenu()} />
					<div class="grow bg-harif-900  min-w-0 overflow-y-auto text-white">
						<Router>
							<BettingSubmenu path="/" default={true} />
							<BettingSubmenu path="/prematch/:any?/:any?/:any?/:any?" />
							<BettingSubmenu path="/live/:any?/:any?/:any?/:any?" />
							<CasinoSubmenu path="/casino/:any?/:any?" />
						</Router>
					</div>
					<div class="border-b border-harif-950 bg-blue-whale-800 py-2 hidden">
						<div class="flex items-center justify-center gap-1 p-2 px-2">
							<div class="w-8">
								<HelpIcon class="w-full" />
							</div>
							<div class="pb-1 text-center">
								<Trans>Need Help</Trans>
							</div>
						</div>
						<div class="mx-auto w-40 rounded bg-sky-600 py-2 text-center text-sm uppercase">
							<Trans>Live chat</Trans>
						</div>
					</div>
				</div>
			</SlidingContainer>
		);
	}
}

export function HorizontalTopMenu({ onClick }) {
	return (
		<div class="overflow-x-auto shrink-0">
			<div class="bg-harif-800 text-white flex" onClick={onClick}>
				<MenuEntry href="/home" regex={/^\/(home|$)/}>
					<span class="px-1 whitespace-nowrap">
						<I.HomeIcon class="h-4 fill-current relative bottom-0.5" />
					</span>
				</MenuEntry>
				<MenuEntry href="/prematch" regex={/^\/prematch/}>
					<span class="px-1 whitespace-nowrap">
						<Trans>Sports</Trans>
					</span>
				</MenuEntry>
				<MenuEntry href="/today" regex={/^\/today/}>
					<span class="px-1 whitespace-nowrap">
						<Trans>Today</Trans>
					</span>
				</MenuEntry>
				<MenuEntry href="/live" regex={/^\/live/}>
					<span class="px-1 whitespace-nowrap">
						<Trans>Live</Trans>
					</span>
				</MenuEntry>
				<MenuEntry href="/virtual" regex={/^\/virtual(?!\/(live|virtual))/}>
					<span class="px-1 whitespace-nowrap">
						<Trans>Virtual</Trans>
					</span>
				</MenuEntry>
				<MenuEntry href="/special-games" regex={/^\/special-games(?!\/(live|virtual))/}>
					<span class="px-1 whitespace-nowrap">
						<Trans>Special Games</Trans>
					</span>
				</MenuEntry>
				<MenuEntry
					href="javascript:void(0);"
					onClick={(e) => {
						e.preventDefault();
						if (User.isLogged()) {
							openPopup(CFeed.getPlayUrl("Atlas-V", "Atlas-V", "keno"));
						} else {
							window.location.href += "#register";
						}
					}}
				>
					<span class="px-1 whitespace-nowrap">
						<Trans>Fast Keno</Trans>
					</span>
				</MenuEntry>
				<MenuEntry href="/jackpots" regex={/^\/jackpots/}>
					<span class="px-1 whitespace-nowrap">
						<Trans>Jackpot</Trans>
					</span>
					<NewBadge />
				</MenuEntry>
				<MenuEntry
					href="javascript:void(0);"
					onClick={(e) => {
						e.preventDefault();
						if (User.isLogged()) {
							openPopup(CFeed.getPlayUrl("Aviator", "aviator", "aviator"));
						} else {
							window.location.href += "#register";
						}
					}}
				>
					<span class="px-1 whitespace-nowrap">
						<Trans>Aviator</Trans>
					</span>
				</MenuEntry>
				<MenuEntry
					href="javascript:void(0);"
					onClick={(e) => {
						e.preventDefault();
						if (User.isLogged()) {
							openPopup(CFeed.getPlayUrl("Aviator", "aviator", "multi-hot-5"));
						} else {
							window.location.href += "#register";
						}
					}}
				>
					<span class="px-1 whitespace-nowrap">
						<Trans>Multi Hot 5</Trans>
					</span>
				</MenuEntry>
				<MenuEntry href="/poker">
					<span class="px-1 whitespace-nowrap">
						<Trans>Poker</Trans>
					</span>
					<NewBadge />
				</MenuEntry>
				<MenuEntry href="/slot-tournaments">
					<span class="px-1 whitespace-nowrap">
						<Trans>Race</Trans>
					</span>
					<NewBadge />
				</MenuEntry>
				<MenuEntry href="/promo">
					<span class="px-1 whitespace-nowrap">
						<Trans>Promo</Trans>
					</span>
				</MenuEntry>
			</div>
		</div>
	);
}

function BettingSubmenu() {
	return (
		<div>
			<div class="pl-6 h-10 flex items-center justify-start bg-harif-800 text-white text-sm">
				Choose a sport
			</div>
			<div class="" onClick={(e) => MobilePage.closeLeftMenu()}>
				{Object.values(PFeed.menu)
					.sort((a, b) => a.order - b.order)
					.map((sport) => (
						<div
							class="h-8 flex items-center text-sm px-4 border-b border-harif-925 gap-2"
							onClick={(e) => route("/prematch/" + sport.id.split("/")[2])}
						>
							<div class="">
								<S.SportIconSmall sport={sport} />
							</div>
							<span>{sport.name}</span>
							<span class="grow"></span>
							<I.AngleRight class="h-3" />
						</div>
					))}
			</div>
		</div>
	);
}
function CasinoSubmenu() {
	return (
		<div>
			<div class="pl-6 h-10 flex items-center justify-start bg-hrf-300 text-white text-sm">
				Choose a brand
			</div>
			<div class="" onClick={(e) => MobilePage.closeLeftMenu()}>
				{Object.values(CFeed.providersList() || {}).map((provider) => (
					<div
						class="h-8 flex items-center text-sm px-4 border-b border-harif-925 gap-2"
						onClick={(e) => route("/casino/brand/" + provider.id)}
					>
						<span>{provider.name}</span>
						<span class="grow"></span>
						<I.AngleRight class="h-3" />
					</div>
				))}
			</div>
		</div>
	);
}
